import type React from 'react';
import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

// eslint-disable-next-line react-hooks/rules-of-hooks
const wrapperState = () => useState<Record<number, boolean>>({});
export type InViewContextData = ReturnType<typeof wrapperState>;

export const InViewContext = createContext<InViewContextData>([{}, () => {}]);

const InViewContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const inViewState = useState<Record<number, boolean>>({});

  return (
    <InViewContext.Provider value={inViewState}>
      {children}
    </InViewContext.Provider>
  );
};

export const useInViewContext = (): InViewContextData =>
  useContext(InViewContext);

export default InViewContextProvider;
